import React, { PropsWithChildren } from 'react';
import { FormField } from './FormField';

export const TextField = ({ name, title, placeholder, children, onChange, tooltip }: TextFieldProps) => {
  return (
    <FormField name={name}
               title={title}
               type="text"
               placeholder={placeholder}
               onChange={(ev) => onChange?.(ev)}
               tooltip={tooltip}>
      {children}
    </FormField>
  );
};

interface TextFieldProps extends PropsWithChildren {
  name: string,
  title?: string,
  placeholder?: string,
  onChange?: (ev: any) => void;
  tooltip?: string;
}